'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { isBlock } from '../../dom/index.js';
import { DEFAULT_BLOCK_ELEMENT } from '../../dom/parseBlockAttributes.js';
import { useBlock } from './hooks/index.js';
import { useBlockAttributes } from './hooks/useBlockAttributes.js';
export function ColumnBlock({ domNode: node = DEFAULT_BLOCK_ELEMENT, children, component: Component, style, }) {
    const { className, name } = useBlock(node);
    const blockAttributes = useBlockAttributes(node);
    return (_jsx(Component, { name: name, domNode: node, className: className, attributes: blockAttributes, style: style, children: children }));
}
/**
 * @internal
 */
// eslint-disable-next-line no-redeclare
(function (ColumnBlock) {
    ColumnBlock.defaultProps = {
        test: (node) => isBlock(node, { tagName: 'div', className: 'wp-block-column' }),
    };
})(ColumnBlock || (ColumnBlock = {}));
